import { ApolloLink } from '@apollo/client';

import { updateApiLicenseLock } from '../../../hooks/use-api-license-lock';
import { API_LICENSE_HEADER_NAME } from '../constants';

export function createApiLicenseLink() {
  const link = new ApolloLink((operation, forward) => {
    return forward(operation).map((data) => {
      const headers = operation.getContext().response.headers as Headers;

      const licenseHeader = headers.get(API_LICENSE_HEADER_NAME);

      // Update the license lock state
      updateApiLicenseLock(licenseHeader);

      return data;
    });
  });

  return link;
}
